import {FormattedMessage} from 'react-intl'

function roleOption(id: string, value: string, search: string) {
  return {
    value,
    search: `${value} ${search}`,
    label: (
      <span>
        <FormattedMessage id={id} /> <span className='text-muted fs-8'>({value})</span>
      </span>
    ),
  }
}

export const roleOptions = [
  roleOption('MENU.ADMINISTRATION', '2', 'admin administration'),
  roleOption('MENU.TEACHER', '3', 'teacher enseignant professeur'),
  roleOption('MENU.STUDENT', '4', 'student élève eleve'),
  roleOption('MENU.PARENT', '5', 'parent'),
  roleOption('ROLE.FINANCE_MANAGER', '6', 'finance manager financier'),
  roleOption('ROLE.STOCK', '7', 'stock inventory inventaire'),
  roleOption('ROLE.LIMITED_STUDENT', '8', 'limited student élève limité'),
  roleOption('ROLE.ACCOUNTANT', '9', 'accountant comptable'),
  roleOption('ROLE.SECRETARY', '10', 'secretary secrétaire secretaire'),
  roleOption('ROLE.ZAD_LIBRARY', '11', 'zad library bibliothèque bibliotheque'),
]

export const governorateOptions = [
  {label: <FormattedMessage id='MENU.ARIANA' />, value: 'Ariana'},
  {label: <FormattedMessage id='MENU.BEJA' />, value: 'Béja'},
  {label: <FormattedMessage id='MENU.BEN_AROUS' />, value: 'Ben Arous'},
  {label: <FormattedMessage id='MENU.BIZERTE' />, value: 'Bizerte'},
  {label: <FormattedMessage id='MENU.GABES' />, value: 'Gabès'},
  {label: <FormattedMessage id='MENU.GAFSA' />, value: 'Gafsa'},
  {label: <FormattedMessage id='MENU.JENDOUBA' />, value: 'Jendouba'},
  {label: <FormattedMessage id='MENU.KAIROUAN' />, value: 'Kairouan'},
  {label: <FormattedMessage id='MENU.KASSERINE' />, value: 'Kasserine'},
  {label: <FormattedMessage id='MENU.KEBILI' />, value: 'Kébili'},
  {label: <FormattedMessage id='MENU.KEF' />, value: 'Kef'},
  {label: <FormattedMessage id='MENU.MAHDIA' />, value: 'Mahdia'},
  {label: <FormattedMessage id='MENU.MANOUBA' />, value: 'Manouba'},
  {label: <FormattedMessage id='MENU.MEDENINE' />, value: 'Médenine'},
  {label: <FormattedMessage id='MENU.MONASTIR' />, value: 'Monastir'},
  {label: <FormattedMessage id='MENU.NABEUL' />, value: 'Nabeul'},
  {label: <FormattedMessage id='MENU.SFAX' />, value: 'Sfax'},
  {label: <FormattedMessage id='MENU.SIDI_BOUZID' />, value: 'Sidi Bouzid'},
  {label: <FormattedMessage id='MENU.SILIANA' />, value: 'Siliana'},
  {label: <FormattedMessage id='MENU.SOUSSE' />, value: 'Sousse'},
  {label: <FormattedMessage id='MENU.TATAOUINE' />, value: 'Tataouine'},
  {label: <FormattedMessage id='MENU.TOZEUR' />, value: 'Tozeur'},
  {label: <FormattedMessage id='MENU.TUNIS' />, value: 'Tunis'},
  {label: <FormattedMessage id='MENU.ZAGHOUAN' />, value: 'Zaghouan'},
]
